/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconButtonProps as MUIIconButtonProps} from '@material-ui/core/IconButton';
import {MaterialBackIcon} from '../../icons/MaterialBackIcon';
import {IconButton, IconButtonProps} from './IconButton';

export interface BackButtonProps extends Omit<MUIIconButtonProps, 'children' | 'color'>,
  Pick<IconButtonProps, 'controlButtonSize' | 'controlButtonPadding' | 'controlFrameSize' | 'controlIconSize'> {
  elementId?: string;
}

/**
 * Back navigation control button rendered via the shared `IconButton`
 * control-button mode.
 *
 * ```typescript
 * import React from 'react';
 * import {BackButton} from '@ion/dls/src/components/buttons/BackButton';
 *
 * const Example = () => (
 *   <BackButton onClick={onBack} />
 * );
 * ```
 */
export const BackButton = ({
  controlButtonSize = 44,
  controlButtonPadding = 0,
  controlFrameSize = 24,
  controlIconSize = 24,
  ...props
}: BackButtonProps) => {
  return (
    <IconButton {...props}
      isControlButton
      controlButtonSize={controlButtonSize}
      controlButtonPadding={controlButtonPadding}
      controlFrameSize={controlFrameSize}
      controlIconSize={controlIconSize}
      icon={<MaterialBackIcon />} />
  );
};

export default BackButton;
